<div class="drawing-notes" data-screenshot-ignore>
  @for (item of notifications; track trackById($index, item)) {
    <div class="drawing-note" [class.drawing-note--failed]="item.failed">
      <div class="drawing-note__icon">
        <i class="fas" [class.fa-circle-check]="!item.failed" [class.fa-circle-exclamation]="item.failed"></i>
      </div>

      <div class="drawing-note__body">
        <div class="drawing-note__title">{{ item.title }}</div>
        <div class="drawing-note__name" [title]="item.fileName">{{ item.fileName }}</div>
        <div class="drawing-note__text">{{ item.message }}</div>

        <div class="drawing-note__actions">
          <button type="button" class="drawing-note__btn drawing-note__btn--primary" (click)="view(item)">
            View
          </button>
          <button type="button" class="drawing-note__btn" (click)="dismiss(item)">
            Dismiss
          </button>
        </div>
      </div>

      <button type="button" class="drawing-note__close" aria-label="Dismiss" (click)="dismiss(item)">
        <i class="fas fa-xmark"></i>
      </button>
    </div>
  }
</div>
